module.exports = __webpack_public_path__ + "static/new_deal_from_template-87f7fb335a01caa93c500e6753594e11.gif";